import { Routes, Route } from "react-router-dom";
import TermsAndConditions from "view/terms/TermsAndConditions";
import TermsAndConditionsCreateEdit from "view/terms/TermsAndConditionsCreateEdit";

const index = () => {
	return (
		<Routes>
			<Route index element={<TermsAndConditions />} />
			<Route path='/create' element={<TermsAndConditionsCreateEdit />} />
			<Route path='/:id/edit' element={<TermsAndConditionsCreateEdit />} />
		</Routes>
	);
};

export default index;
